import type { FunctionComponent } from "react";
import { useContext } from "react";

import { GalleryContext } from "~/components/image-gallery/contexts";

import { ToolbarButton } from "./toolbar-button";

export const ToolbarButtonClose: FunctionComponent = () => {
  const { instance } = useContext(GalleryContext);

  return (
    <ToolbarButton
      icon="close"
      title="Close"
      onClick={() => {
        instance?.close();
      }}
    />
  );
};

ToolbarButtonClose.displayName = "ToolbarButtonClose";
